import { WrappedComponentProps } from 'react-intl'
import {
  CollectionListHorizontal,
  LinkText,
} from 'shared-global-ec-uikit/components/dist/react/esm'
import getConstants from '../../constants'
import { locales } from 'constants/locales'

type Props = WrappedComponentProps

const FooterLinks = ({ intl }: Props) => {
  const CONSTANTS = getConstants()

  const regionConfig = locales[CONSTANTS.COUNTRY as keyof typeof locales]

  const footerLinks = [
    {
      text: intl.formatMessage({
        id: 'text_termsof_conditions',
      }),
      href: regionConfig.TERMS_OF_USE_URL,
    },
    {
      text: intl.formatMessage({
        id: 'text_privacy_policy',
      }),
      href: regionConfig.PRIVACY_POLICY_URL,
    },
  ]

  return (
    <CollectionListHorizontal
      divider
      alignment="stretch"
      spacingValue="12"
      className="fr-ec-mb-spacing-01"
    >
      {footerLinks.map(link => (
        <LinkText
          key={link.text}
          href={link.href}
          variant="standalone-secondary"
          target="_blank"
          element="a"
        >
          {link.text}
        </LinkText>
      ))}
    </CollectionListHorizontal>
  )
}

export default FooterLinks
